import { render, staticRenderFns } from "./BuilderMain.vue?vue&type=template&id=0c20445d&scoped=true&"
import script from "./BuilderMain.vue?vue&type=script&lang=js&"
export * from "./BuilderMain.vue?vue&type=script&lang=js&"
import style0 from "./BuilderMain.vue?vue&type=style&index=0&id=0c20445d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c20445d",
  null
  
)

export default component.exports